export default __webpack_public_path__ + "static/media/icon-twitter.eb3f0c70.svg";